var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickBlueOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_209_34785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.95837 0.833008C4.92504 0.833008 0.833374 4.92467 0.833374 9.95801C0.833374 14.9913 4.92504 19.083 9.95837 19.083C14.9917 19.083 19.0834 14.9913 19.0834 9.95801C19.0834 4.92467 14.9917 0.833008 9.95837 0.833008ZM17.5 9.95801C17.5 14.1163 14.1167 17.4997 9.95837 17.4997C5.80004 17.4997 2.41671 14.1163 2.41671 9.95801C2.41671 5.79967 5.80004 2.41634 9.95837 2.41634C14.1167 2.41634 17.5 5.79967 17.5 9.95801Z",
    fill: "#146EB4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9589 7.032C14.2325 7.30075 14.2365 7.74043 13.9677 8.01406L9.19341 12.8752C9.06283 13.0081 8.8843 13.083 8.69796 13.083C8.51161 13.083 8.33308 13.0081 8.20251 12.8752L6.03237 10.6656C5.76363 10.3919 5.76759 9.95226 6.04122 9.68352C6.31485 9.41477 6.75453 9.41874 7.02327 9.69236L8.69796 11.3975L12.9768 7.04085C13.2456 6.76722 13.6852 6.76326 13.9589 7.032Z",
    fill: "#146EB4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_209_34785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickBlueOutline);
export default __webpack_public_path__ + "static/media/tick-blue-outline.50b8920d90972a684e5afb4abcdd35dc.svg";
export { ForwardRef as ReactComponent };